import {
  ModalAddStandard,
  PreOrderArticles,
  PreOrderFilter,
} from "../components";
import { useEffect } from "react";
import { useAppDispatch } from "../../../hooks";
import { fetchMySites } from "../../../redux/slices/mySitesSlice";
import { fetchClientsBySalesRepresentative } from "../../../redux/slices/clientsSlice";
import SpecialAddModal from "../components/SpecialAddModal";

const PreCommandesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Sites de vente / d'expédition affectés au représentant connecté.
    dispatch(fetchMySites());
    dispatch(fetchClientsBySalesRepresentative());
  }, [dispatch]);

  return (
    <>
      <ModalAddStandard />
      <SpecialAddModal />
      <PreOrderFilter />
      <PreOrderArticles />
    </>
  );
};

export default PreCommandesPage;
